export default __webpack_public_path__ + "c92639a35eb5605adbb01c5bef429c5f.png";